/* eslint-disable no-underscore-dangle */
import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchStationsTemplatesPreview, fetchedStationsTemplatesPreview } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';
import { sagaWithCallback } from '../utils';

type FetchStationsTemplatesPreviewActionPayload = ReturnType<typeof fetchStationsTemplatesPreview>;

export function* getStationsTemplatesPreviewSaga({ meta }: FetchStationsTemplatesPreviewActionPayload) {
  const { getStationsTemplatesPreview } = getAPI();
  const response: YieldOf<typeof getStationsTemplatesPreview> = yield call(
    getStationsTemplatesPreview,
    meta.formValues
  );
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedStationsTemplatesPreview(data));
    return data;
  } else {
    const error = problem || 'unknown';
    yield put(fetchedStationsTemplatesPreview(undefined, error));
    throw new Error(data?.message || `preview_templates_failed`);
  }
}

export default function* TemplateSaga() {
  yield takeLatest(fetchStationsTemplatesPreview.type, sagaWithCallback(getStationsTemplatesPreviewSaga));
}
